import NavBreadcrum from "components/NavBreadcrum";
import MapHomeBridge from "./MapHomeBridge";
import TableAlertsBridge from "./TableAlertsBridge";
import SumaryDataBridge from "./SumaryDataBridge";

const HomeBridge = () => {
    return (
        <>
            <NavBreadcrum navs={[{name: "labels.home", url: "/", icon: "home"}]} bread={[]} />
            <div className="row">
                <div className="col-md-10 col-12">
                    <div className="col-12 pt-2">
                        <MapHomeBridge />
                    </div>
                </div>
                <div className="col-md-2 col-12">
                    <div className="row">
                        <div className="col-12">
                            <SumaryDataBridge />
                        </div>
                    </div>
                </div>
                <div className="col-12 mt-3">
                    <TableAlertsBridge />
                </div>
            </div>
        </>
    );
};
export default HomeBridge;
